import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Login14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6.11617 0.823209C6.60433 0.335053 7.39578 0.335053 7.88394 0.823209L13.1768 6.1161C13.665 6.60426 13.665 7.39571 13.1768 7.88387L7.88394 13.1768C7.39578 13.6649 6.60433 13.6649 6.11617 13.1768L3.46973 10.5303L4.53039 9.46966L7.00006 11.9393L11.9394 6.99999L7.00006 2.06065L4.53039 4.53032L3.46973 3.46966L6.11617 0.823209Z'
      fill='currentColor'
    />
    <path
      d='M6.5 7.75L1 7.75V6.25L6.5 6.25V4.5L9 7L6.5 9.5V7.75Z'
      fill='currentColor'
    />
  </Svg>
);

Login14.displayName = 'Login14';
export default Login14;
